import { SVG } from './SVG';
const IconFacebookAlt1 = () => {
  return (
    <SVG width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 2.66992H15C13.6739 2.66992 12.4021 3.19671 11.4645 4.13439C10.5268 5.07207 10 6.34384 10 7.66992V10.6699H7V14.6699H10V22.6699H14V14.6699H17L18 10.6699H14V7.66992C14 7.40471 14.1054 7.15035 14.2929 6.96282C14.4804 6.77528 14.7348 6.66992 15 6.66992H18V2.66992Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};

export { IconFacebookAlt1 as default, IconFacebookAlt1 };
